const jsonSchema = [
  {
    name: 'name',
    label: 'Company Name',
    type: 'text',
    required: true,
    showInList: true
  },
  {
    name: 'address',
    label: 'Address',
    type: 'text',
    required: true,
    showInList: true
  },
  {
    name: 'postcode',
    label: 'Postcode',
    type: 'text',
    showInList: true,
    required: false
  },
  {
    name: 'country',
    label: 'Country',
    type: 'text',
    required: true,
    showInList: true
  },
  {
    name: 'telephone',
    label: 'Telephone',
    type: 'text',
    required: false,
    showInList: true
  }, 
  {
    name: 'usersLimit',
    label: 'Users Limit',
    type: 'number',
    required: false,
    showInList: true
  },
  {
    name: 'numberOfEmployees',
    label: 'Number of Employees',
    type: 'number',
    required: false,
    showInList: true
  }
];
export default jsonSchema;
